import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import { Tree, Input, Col, Spin, Checkbox, Popover } from 'antd';
import { FolderOpenOutlined, UserOutlined, SearchOutlined } from '@ant-design/icons';
import { cloneDeep, debounce } from 'lodash';
import { callApi } from 'utils';
import PersonInfo from '../components/PersonInfo';
import { SelectContext } from '../context';
const TreeNode = Tree.TreeNode;
const prefixClx = 'select-modal-new';

class SelectUserAndDept extends Component {
	static contextType = SelectContext;
	constructor (props) {
		super(props);
		this.state = {
			selectedKeys: [],
			expandedKeys: [],
			disabledObj: this.getDisabledObj(props.disabledSelects),
			scrollViewHeight: 0,
		};
		this.treeBox = createRef();
		this.searchBox = createRef();
	}

	componentDidMount () {
		const { organizations, selects } = this.props;
		this.setTreeStatus(selects);
		let scrollViewHeight = 0;
		if (this.treeBox.current && this.searchBox.current) {
			const searchBox = window.getComputedStyle(this.searchBox.current);
			scrollViewHeight = this.treeBox.current.parentElement.clientHeight - parseInt(searchBox.height) - parseInt(searchBox.marginTop) - parseInt(searchBox.marginBottom);
		}
		this.setState({
			scrollViewHeight,
		});
		if (organizations) {
			const expandedKeys = [`dep${organizations.id}`];
			this.setTreeStatus(selects);
			this.setState({
				expandedKeys
			});
		}
		this.handleCompatibleData(selects);
	}

	componentWillReceiveProps (nextProps) {
		const { organizations, selects } = this.props;
		if (selects !== nextProps.selects && nextProps.selects) {
			this.setState({
				selectedKeys: nextProps.selects.reduce((acc, cur) => {
					if (cur.flowUserSelectionType === 'user' || cur.flowUserSelectionType === 'person') {
						acc.push(`${cur.sourceIdB}-${cur.sourceIdA}`);
					} else if (cur.flowUserSelectionType === 'department') {
						acc.push(`dep${cur.sourceIdA}`);
					}
					return acc;
				}, []),
			});
		}
		if (organizations !== nextProps.organizations && nextProps.organizations) {
			this.setTreeStatus(nextProps.selects);
		}
	}

	// 处理数据兼容
	handleCompatibleData = (selects) => {
		const oldSelects = [...selects];
		const toHandleData = [];
		const selectedKeys = [];
		selects.forEach((item, idx) => {
			// 选用户兼容，没有部门id时设置主部门id
			if (item.flowUserSelectionType === 'person' || item.sourceTypeA === 'source_user') {
				if (item.sourceIdB === undefined) {
					toHandleData.push({
						pos: idx,
						id: item.sourceIdA,
					});
				} else {
					selectedKeys.push(`${item.sourceIdB}-${item.sourceIdA}`);
				}
			}
			if (item.flowUserSelectionType === 'department') {
				selectedKeys.push(`dep${item.sourceIdA}`);
			}
		});
		this.setState({
			selectedKeys,
		});
		if (toHandleData.length) {
			const { manageSceneFlag } = this.context;
			callApi({
				api: '/org_v6/listPrimaryDepartmentByUser',
				data: {
					manageSceneFlag,
					organizationId: this.props.organizations.id,
					detailIds: toHandleData.map(it => it.id),
				},
				success: (res = []) => {
					// 新的数据
					const newSelects = [...oldSelects];
					res.forEach((it, idx) => {
						newSelects[toHandleData[idx].pos] = { ...selects[toHandleData[idx].pos], sourceIdB: it.organizationDTO.id, sourceTypeB: 'source_department' };
					});
					// 删除旧数据
					this.props.removeItems(toHandleData.map(it => oldSelects[it.pos]));
					// 添加新数据
					this.props.addItems(toHandleData.map(it => newSelects[it.pos]));
				}
			});
		}
	};

	//封装不可选择列表
	getDisabledObj = (disabledList = []) => {
		const obj = {};
		disabledList.forEach(val => {
			obj[Number(val.sourceIdA)] || (obj[Number(val.sourceIdA)] = true);
		});
		return obj;
	};

	/**
	 * 设置树节点的状态
	 */
	setTreeStatus = (selects) => {
		const selectedKeys = [];
		selects.forEach(item => {
			const treeNode = this.getTreeNode(item.sourceIdA);
			const childKeys = this.getTreeChildKeys(treeNode.childrens);
			selectedKeys.push(String(item.sourceIdA));
			for (let key of childKeys) {
				key = String(key);
				selectedKeys.push(key);
			}
		});
		this.setState({
			selectedKeys,
		});
	};

	/**
	 * 获取树节点
	 */
	getTreeNodes = () => {
		const { organizations } = this.props;
		return organizations ? this.generateNodes([organizations]) : [];
	};

	/**
	 * 生成部门组织树状数据结构
	 */
	generateNodes = list => {
		const { disabledObj } = this.state;
		const { untrackStatus, selects, isLazyLoadData } = this.props;
		return list.map(node => {
			let { children = [], name, id, contactInfoDTOS = [], detailId, selectedFlag, targetId, organizationId, isLeaf, isUser } = node;
			if (contactInfoDTOS.length > 0) {
				contactInfoDTOS.forEach(val => {
					val.id = val.detailId;
					val.isUser = true;
				});
				children = children.concat(contactInfoDTOS);
			}
			if (!isUser) {
				const parentsSelected = (() => {
					if (disabledObj[id] || selectedFlag === 0) {
						return false;
					}
					return selects.some(selectNode => selectNode.sourceIdA === id);
				})();
				return (
					<TreeNode
						allData={node}
						key={`dep${id}`}
						disabled={disabledObj[id] || selectedFlag === 0}
						isLeaf={ isLazyLoadData && !!isLeaf }
						title={
							<div title={name}
								className={`${prefixClx}-node`}
							>
								<span className={`${prefixClx}-node-name`}>
									<FolderOpenOutlined className='type-icon' />
									{name}
								</span>
								<span className={`${prefixClx}-node-handle`}>
									<Checkbox disabled={disabledObj[id] || selectedFlag === 0} checked={parentsSelected} />
								</span>
							</div>}>
						{this.generateNodes(children)}
					</TreeNode>
				);
			}
			const selected = (() => {
				if (disabledObj[id] || selectedFlag === 0 || (untrackStatus === 1 && targetId === 0)) {
					return false;
				}
				return selects.some(selectNode => selectNode.sourceIdA === targetId);
			})();
			return (
				<TreeNode
					allData={node}
					key={`${organizationId}-${targetId === 0 ? 'diabled-' + id : ''}${targetId}`}
					disabled={disabledObj[id] || selectedFlag === 0 || (untrackStatus === 1 && targetId === 0)}
					isLeaf={ isUser || (isLazyLoadData && !!isLeaf) }
					title={
						<div title={name + (targetId === 0 ? '（未激活）' : '')}
							className={`${prefixClx}-node`}
						>
							<Popover title={name} mouseEnterDelay={0.5} content={<PersonInfo detail={node} />}>
								<span className={`${prefixClx}-node-name`}>
									{isUser ? <UserOutlined className='type-icon' /> : <FolderOpenOutlined className='type-icon' />}{name}{(targetId === 0 ? '（未激活）' : '')}
								</span>
							</Popover>
							<span className={`${prefixClx}-node-handle`}>
								<Checkbox disabled={disabledObj[id] || selectedFlag === 0 || (untrackStatus === 1 && targetId === 0)} checked={selected} />
							</span>
						</div>}
				/>
			);
		});
	};

	/**
	 * 选中树节点
	 */
	selectTreeNode = (keys, info) => {
		const { props } = this;
		const sNode = info.node;
		const { allData } = sNode;

		if (sNode) {
			const newSelect = allData.detailId
				? {
						selectionName: allData.name || allData.contactName,
						flowUserSelectionType: 'person',
						sourceIdA: allData.targetId,
						sourceTypeA: 'source_user',
						sourceDataA: props.needAllData ? allData : undefined,
						sourceIdB: allData.organizationId,
						sourceTypeB: 'source_department',
					}
				: {
						selectionName: allData.name,
						flowUserSelectionType: 'department',
						sourceIdA: allData.id,
						sourceTypeA: 'source_department',
						sourceDataA: props.needAllData ? allData : undefined,
					};
			const hasSelectd = props.selects.find(selectItem => selectItem.sourceIdA === newSelect.sourceIdA);
			if (!hasSelectd) {
				props.addItems([newSelect]);
			} else if (hasSelectd) {
				props.removeItems([newSelect]);
			}
		}
	};

	/**
	 * 获取当前选中的树节点
	 */
	getTreeNode = (id) => {
		const { organizations = {} } = this.props;
		let treeNode = null;
		const loop = (childrens = []) => {
			for (const item of childrens) {
				if (treeNode) break;
				if (item.id === id) {
					treeNode = item;
					break;
				} else {
					loop(item.childrens);
				}
			}
		};
		if (organizations.id === id) {
			treeNode = organizations;
		} else {
			loop(organizations.childrens);
		}
		return treeNode || {};
	};

	/**
	 * 获取当前选中树节点的子节点keys
	 */
	getTreeChildKeys = (childrens) => {
		const childKeys = [];
		const loop = (childrens = []) => {
			childrens.forEach(item => {
				childKeys.push(item.id);
				if (item.childrens && item.childrens.length) loop(item.childrens);
			});
		};
		loop(childrens);
		return childKeys;
	};

	/**
	 * 点击展开/收缩树节点
	 */
	onExpand = (keys, info) => {
		this.setState({
			expandedKeys: keys
		});
	};

	/**
	 * 生成搜索结果数据结构
	 */
	generateList = () => {
		const { disabledObj, searchList } = this.state;
		const { untrackStatus, selects } = this.props;
		return searchList.map(node => {
			const { contactName, name, id, selectedFlag, detailId, targetId, organizationId } = node;
			const selected = (() => {
				if (disabledObj[id] || selectedFlag === 0 || (untrackStatus === 1 && targetId === 0)) {
					return false;
				}
				if (!detailId) return selects.some(selectNode => selectNode.sourceIdA === id);
				return selects.some(selectNode => selectNode.sourceIdA === targetId);
			})();
			const searchKey = detailId ? `${organizationId}-${targetId}${targetId === 0 ? detailId : ''}` : `dep${id}`;
			return <TreeNode
				allData={node}
				key={searchKey}
				disabled={disabledObj[targetId] || selectedFlag === 0 || (untrackStatus === 1 && targetId === 0)}
				title={<div className={`${prefixClx}-node`}>
					<Popover title={contactName} mouseEnterDelay={0.5} content={<PersonInfo detail={node} />}>
						<span className={`${prefixClx}-node-name`}>
							{detailId ? <UserOutlined className='type-icon'/> : <FolderOpenOutlined className='type-icon' />}{name || contactName}{(targetId === 0 ? '（未激活）' : '')}
						</span>
					</Popover>
					<span className={`${prefixClx}-node-handle`}>
						<Checkbox disabled={disabledObj[targetId] || selectedFlag === 0 || (untrackStatus === 1 && targetId === 0)} checked={selected} />
					</span>
				</div>} />;
		});
	};

	/**
	 * 根据关键字搜索
	 */
	searchByKeywords = (keywords = '') => {
		const { organizations, privilegeFilterFlag, hiddenFilterFlag = 0 } = this.props;
		const { manageSceneFlag } = this.context;
		keywords = keywords.trim();
		if (keywords) {
			this.setState({ loading: true, showSearchBox: true, searchText: keywords });
			callApi({
				api: '/newOrg/findOrgPersonal',
				data: {
					organizationId: organizations.id,
					keywords,
					privilegeFilterFlag,
					appId: window.$$context.appId,
					hiddenFilterFlag,
					manageSceneFlag
				},
				success: ({ members = [], departments = [] }) => {
					this.setState({
						searchList: departments.concat(members),
						loading: false,
					});
				}
			});
		} else {
			this.setState({
				loading: true,
				searchList: [],
				showSearchBox: true,
				searchText: keywords,
			}, () => {
				this.setState({ loading: false });
			});
		}
	};

	// 防抖
	searchByKeywordsDebounced = debounce(this.searchByKeywords, 500);

	render () {
		const { selectedKeys, expandedKeys, searchText, searchList, loading, showSearchBox, scrollViewHeight } = this.state;
		const { lazyLoadOrganization } = this.props;
		return (
			<Col className='tree-box' ref={this.treeBox}>
				<div className='select-box-search' ref={this.searchBox}>
					<Input
						placeholder="请输入部门/用户名字"
						onChange={(e) => this.searchByKeywordsDebounced(e.target.value)}
						prefix={<SearchOutlined />}
						allowClear
					/>
				</div>
				<div className={'select-scroll-view'}>
					{
						showSearchBox && searchText
							? loading
								? <Spin className='tree-box-center' />
								: searchList.length < 1
									? <div className='tree-box-center'>未找到相关结果</div>
									: <Tree
											multiple
											height={scrollViewHeight}
											onSelect={this.selectTreeNode}
											onExpand={this.onExpand}
											selectedKeys={selectedKeys}
										>
											{this.generateList()}
										</Tree>
							: loading ? <Spin className='tree-box-center' /> : <Tree
								multiple
								height={scrollViewHeight}
								expandedKeys={cloneDeep(expandedKeys)}
								onSelect={this.selectTreeNode}
								onExpand={this.onExpand}
								selectedKeys={selectedKeys}
								loadData={lazyLoadOrganization}
							>
								{this.getTreeNodes()}
							</Tree>

					}
				</div>
			</Col>
		);
	}
}

SelectUserAndDept.propTypes = {
	organizations: PropTypes.object.isRequired, // 组织架构数据
	// 选中的列表， 数据结构为 [{selectionName: 显示名称, flowUserSelectionType: 'department', sourceIdA: ID, sourceTypeA: 'source_department'}]
	// selectionName、sourceIdA 必传， flowUserSelectionType、sourceTypeA 都为固定值，根据义务是否有需求来选择传入
	selects: PropTypes.array.isRequired,
	onChange: PropTypes.func.isRequired,       // 选中的列表改变时的回调
	// 未注册用户的状态：1 不可选择（默认），2 可选择
	untrackStatus: PropTypes.number,
	hiddenFilterFlag: PropTypes.number,

	isLazyLoadData: PropTypes.bool, // 是否使用对数据进行懒加载的功能
	lazyLoadOrganization: PropTypes.func, // 使用懒加载数据的时候，需要在获取子部门时调用的方法
};
SelectUserAndDept.defaultProps = {
	needAllData: false,
	untrackStatus: 1,
	hiddenFilterFlag: 0,
};
export default SelectUserAndDept;
